import { createSelector } from 'reselect';
import { RootState } from 'store/types';
import { UserInsuranceInfo } from './types';

// EVisit Session
export const eVisitSessionSelector = (state: RootState) => state.eVisit.session;
export const eVisitSessionFetchingSelector = createSelector(
  eVisitSessionSelector,
  session => session.eVisit.isFetching
);
export const eVisitSessionErrorSelector = createSelector(
  eVisitSessionSelector,
  session => session.eVisit.error
);
export const eVisitSessionTokenSelector = createSelector(
  eVisitSessionSelector,
  session => session.eVisit.eVisitSessionToken
);
export const isEVisitFrontDoorSelector = createSelector(
  eVisitSessionSelector,
  session => session.eVisit.isEVisitFrontDoor
);
export const eVisitSessionStateSelector = createSelector(
  eVisitSessionSelector,
  session => session.eVisit.eVisitState
);

export const insuranceSummaryStateSelector = createSelector(
  eVisitSessionSelector,
  eVisit => eVisit.insuranceSummary
);

export const insuranceSummaryStateDataSelector = createSelector(
  insuranceSummaryStateSelector,
  state => state?.data || ({} as UserInsuranceInfo)
);

export const insuranceSummaryStateIsFetchingSelector = createSelector(
  insuranceSummaryStateSelector,
  state => !!state?.isFetching
);
export const sendInsuranceLoadingSelector = (state: RootState) =>
  state.eVisit?.session?.sendInsurance?.isFetching;

export const sendInsuranceFailSelector = (state: RootState) =>
  state.eVisit?.session?.sendInsurance?.error;

// EVisit Eligibility
export const eVisitEligibilitySelector = (state: RootState) => state.eVisit.eligibility;
export const eVisitEligibilityRequestStateSelector = createSelector(
  eVisitEligibilitySelector,
  eligibility => eligibility?.requestState
);
export const eVisitEligibilityAccessSelector = createSelector(
  eVisitEligibilitySelector,
  eligibility => eligibility?.data?.access
);
export const eVisitEligibilityFetchingSelector = createSelector(
  eVisitEligibilitySelector,
  eligibility => eligibility?.isFetching
);

// EVisit appSettings SLA
export const eVisitSLASelector = (state: RootState) => state.appSettings.shared.evisit.sla;

// EVisit Insurance
export const eVisitInsuranceSelector = (state: RootState) => state.eVisit.insurance;
export const eVisitUserInsuranceInfoSelector = createSelector(
  eVisitInsuranceSelector,
  insurance => insurance?.userInfo
);
export const eVisitInsuranceFilesSelector = createSelector(
  eVisitInsuranceSelector,
  insurance => insurance?.insuranceFiles
);
